import ShDatePicker from './src/main.vue'

ShDatePicker.install = function (Vue) {
  Vue.component(ShDatePicker.name, ShDatePicker)
}

export default ShDatePicker
